<template>
    <div class="payment__form">
        <div v-if="step === 0">
            <h5
                class="container__col-md-12 container__col-sm-12 payment__body__title"
            >
                {{$t("migo.step.one.title")}}
            </h5>

            <primary-input
                type="tel"
                :title="$t('migo.input.phone')"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone.svg"
                placeholder="07013926478"
                @value-change="telephone = $event"
            />
            <PrimaryButton
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                @click="checkPhoneNumber"
            />
        </div>
        <div v-else-if="step === 1">
            <h5
                class="container__col-md-12 container__col-sm-12 payment__body__title"
            >
                {{$t("migo.step.two.title")}}
            </h5>

            <primary-input
                type="tel"
                :title="$t('migo.input.phone')"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone"
                placeholder="07013926478"
                @value-change="telephone = $event"
            />
            <primary-input
                type="tel"
                :title="$t('migo.input.account')"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="account-number"
                placeholder="07013926478"
                @value-change="accountNumber = $event"
            />
            <PrimaryButton
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                @click="checkPhoneNumber"
            />
        </div>
        <div v-else-if="step === 2"></div>
    </div>
</template>

<script>
import PrimaryButton from "@/components/form/base-button";
import PrimaryInput from "@/components/form/base-input";
export default {
    name: "PayWithMigo",
    components: { PrimaryInput, PrimaryButton },
    data() {
        return {
            step: 0,
            bank: "",
            telephone: "",
            accountNumber: "",
            transactionSuccessful: false,
        };
    },
    methods: {
        changeStep(step) {
            this.step = step;
        },
        checkPhoneNumber() {
            this.changeStep(1);
        },
        checkPhoneAndAccount() {
            this.changeStep(2);
        },
    },
};
</script>

<style scoped>
</style>